// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fnDa","type":"styles_type__2OQby","choices":"styles_choices__3rC-_"};